<template>
  <v-container class="pa-0">
    <v-row  >
     <v-col class="py-0 px-3" cols="12" sm="6" md="3" lg="3">
      <label>Ordenar por</label>
      <v-select
          v-model="orderBy"
          :items="orderByList"
          item-value="valor"
          item-text="descricao"
          :menu-props="{ bottom: true, offsetY: true }"
          flat
          solo
          dense
          outlined
          @change="getList({...filterData, ...orderBy}, 1)"
      ></v-select>
    </v-col>
    <v-spacer/>
    <v-col class="d-flex justify-end pt-3 pb-0 px-0" cols="12" sm="6"  md="3" lg="3">
      <v-btn
        color="primary"
        text
        @click="downloadFile('getcsvpagamentosprocessamento', filterData, true)"
        :disabled="list.length == 0"
      >
        <v-icon small class="pr-2">fa-download</v-icon>
        Exportar resultado
      </v-btn>
    </v-col>
    </v-row>
    <v-row 
        v-if="list.length > 0"
        class="ma-0 pl-4 pr-2" 
        style="background-color: #d1dcea">
        <v-col cols="2" class="pa-4">
          <div class="px-5 pt-1">
            <b class="pr-2">TOTAIS</b>
          </div>
        </v-col>
        <v-col cols="10" class="pa-0">
          <v-row class="ma-0 pt-2 pr-11" style="justify-content: end;">
            <v-spacer/>
            <v-col class="text-list text-right px-0 py-1" style="max-width:13.6%">
              <small>Pagamento estimado:</small><br />
              <b><span>R$ {{ totais.valor_liberado | formatPrice }}</span></b>
            </v-col>
            <v-col class="text-list text-right px-0 py-1" style="max-width:13.6%">
              <small>Glosa estimada:</small><br />
              <b><span style="color: red;">R$ {{ totais.valor_glosado | formatPrice }}</span></b>
            </v-col>
          </v-row>  
        </v-col>              
      </v-row>
    <p class="text-center pt-6 pa-2" v-show="list.length === 0">
      Não há dados disponíveis
    </p>
    
    <v-expansion-panels focusable v-model="panel" v class="px-0 pt-3">
      <v-expansion-panel
        v-for="(pagamento, ind) in list"
        :key="ind"
        class="mb-4 pa-0"
        @click="showOpen(pagamento)"
      >
        <v-expansion-panel-header class="py-0 px-3">
          <v-row class="ma-3">
            <v-col cols="2" class="pa-0">
              <div v-if="pagamento.erro" class="warning-header">
                <v-tooltip bottom open-delay="500">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on"
                      ><v-icon class="pt-2 pr-1" color="error" small
                        >fas fa-exclamation-circle</v-icon
                      ></span
                    >
                  </template>
                  <span
                    class="px-3 py-1 ma-0"
                    style="
                      border: solid 1px #999;
                      border-radius: 5px;
                      background-color: #fff;
                    "
                    >{{ pagamento.evento }}</span
                  >
                </v-tooltip>
              </div>
              <div class="px-0 py-3 ml-7">
                <b class="pr-2"
                  ><small>Data do pagamento:</small><br />{{
                    pagamento.data_pagamento | formatDate
                  }}</b
                >
                <!-- <v-tooltip bottom open-delay="500">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on"
                      ><b>{{ pagamento.date_pag | formatDate }}</b></span>
                  </template>
                  <span
                    class="px-3 py-1 ma-0"
                    style="border: solid 1px #999; border-radius: 5px; background-color: #FFF"
                    >{{ pagamento.prest_nome }}</span
                  >
                </v-tooltip> -->
              </div>
            </v-col>
            <v-col cols="10" class="pa-0">
              <v-row class="ma-0">
                <v-col cols="1" class="text-list text-left px-0 py-3">
                  <small>SLA:</small><br />
                  <span>{{ sla[pagamento.qtd_dias] }}</span>
                </v-col>
                <v-col class="text-list text-left px-0 pb-3 py-3">
                  <b>{{ pagamento.oper_nome }}</b><br />
                  <b style="font-weight: 400;">{{ pagamento.prest_nome }}</b>
                </v-col>
                <!-- <v-col class="text-list text-left px-0 pb-3 pt-5"
                  ><b>{{ pagamento.prest_nome }}</b></v-col
                > -->
                <!-- <v-spacer></v-spacer> -->
                <v-col class="text-list text-right px-0 py-3" style="max-width: 13.6%;">
                  <small>Identificado em:</small><br />
                  <b style="font-weight: 400;">{{ pagamento.data_identificacao | formatDate }}</b>
                </v-col>
                <v-col class="text-list text-right px-0 py-3" style="max-width: 17.6%;">
                  <small>Pagamento estimado:</small><br />
                  <b>R$ {{ pagamento.valor_liberado | formatPrice }}</b>
                </v-col>
                <v-col class="text-list text-right px-0 py-3" style="max-width: 13.6%;">
                  <small>Glosa estimada:</small><br />
                  <span style="color: red">R$ {{ pagamento.valor_glosado | formatPrice }}</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- {{ind}} -->
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-data-table
            dense
            :headers="headers"
            :items="historico"
            hide-default-footer
          >
            <template v-slot:item="props">
              <tr>
                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" class="pr-2">
                        <v-icon :color="colorList[props.item.status]" small>
                          {{iconList[props.item.status] }}
                        </v-icon>
                      </span>
                    </template>
                    <span
                      class="px-3 py-1 ma-0"
                      style=" border: solid 1px #999; border-radius: 5px; background-color: #fff;"
                      >
                      {{ labelList[props.item.status] }}
                      </span>
                  </v-tooltip>
                  {{ props.item.data_evento | formatDateHour }}
                </td>
                <td>
                  {{ props.item.identificador_prestador }}
                </td>
                
                <td class="">
                  <span v-if="!props.item.erro"> {{ props.item.mensagem ? props.item.mensagem : ''}}</span>
                  <span v-else style="color: #d0021b"
                    >{{ props.item.evento }}
                     <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" class="pr-1">

                    <v-btn
                      v-if="props.item.evento_id == 100"
                      @click="setFilter(pagamento, 'identNaOperadoraFilter')"
                      class="pb-1"
                      x-small
                      color="primary"
                      icon
                    >
                      <v-icon x-small>fas fa-external-link-alt</v-icon>
                    </v-btn>
                     </span>
                    </template>
                    <span
                      class="px-3 py-1 ma-0"
                      style="
                        border: solid 1px #999;
                        border-radius: 5px;
                        background-color: #fff;
                      "
                      >Identificação na operadora</span
                    >
                  </v-tooltip>
                    
                    <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" class="pr-1">
                        <v-btn
                        v-if="props.item.doc_id_download"
                        class="pb-1"
                        x-small
                        color="primary"
                        icon
                        @click="getFile(props.item.doc_id_download)"
                      >
                        <v-icon x-small>fa-download </v-icon>
                      </v-btn>
                      </span>
                    </template>
                    <span
                      class="px-3 py-1 ma-0"
                      style="
                        border: solid 1px #999;
                        border-radius: 5px;
                        background-color: #fff;
                      "
                      >Baixar arquivo</span
                    >
                  </v-tooltip>
                  </span>
                  <span>
                    <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" class="pr-1">
                     <v-btn
                      v-if="props.item.evento_id == 3"
                      class="pb-1"
                      x-small
                      color="primary"
                      icon
                      @click="setFilter(pagamento, 'lotesPendentes')"
                    >
                      <v-icon x-small>fas fa-external-link-alt</v-icon>
                    </v-btn>
                    </span>
                    </template>
                    <span
                      class="px-3 py-1 ma-0"
                      style="
                        border: solid 1px #999;
                        border-radius: 5px;
                        background-color: #fff;
                      "
                      >Lotes complementares</span
                    >
                  </v-tooltip>
                  </span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-row>
      <v-col cols="4"></v-col>
      <v-col class="text-center mt-2 py-0" cols="4">
        <v-pagination
          class="no-box-shadow"
          v-model="pagination.offset"
          :length="pagination.total_pages"
          @input="getList(filterData, pagination.offset)"
        ></v-pagination>
      </v-col>
      <v-col cols="4"></v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import { dragscroll } from "vue-dragscroll";
export default {
  directives: { dragscroll },
  data() {
    return {
      panel: false,
      headersFixed: [
        {
          text: "Operadora",
          value: "prestador_id",
          sortable: false,
          align: "start",
          class: "px-5",
        },
        {
          text: "Prestador",
          value: "operadora_ans_id",
          sortable: false,
          align: "start",
          class: "px-5",
        },
      ],
      headers: [
        { text: "Data do evento", value: "data_evento", sortable: false },
        { text: "Ident.", value: "identificador_prestador", sortable: false },
        { text: "Evento", value: "evento", sortable: false },
      ],
      sla: {
        3: "D3",
        5: "D5",
        6: "D>5",
      },
      colorList:{
          executado: "success", 
          em_execucao: "warning",
          com_intercorrencia: "error"
        },
      iconList:{
        executado: "fa-check-circle", 
        em_execucao: "fas fa-exclamation-triangle",
        com_intercorrencia: "fas fa-exclamation-circle"
      },
      labelList:{
        executado: "Executado", 
        em_execucao: "Em execução",
        com_intercorrencia: "Com intercorrência"
      },
      orderBy: null,
      orderByList:[
        {descricao: "Selecione", valor: null},
        {descricao: "Data de identificação mais antiga", valor:{sort: 'data_identificacao', order:'Asc'}},
        {descricao: "Data de identificação mais recentes", valor:{sort: 'data_identificacao', order:'Desc'}},
        {descricao: "Maiores valores de pagamento estimado", valor:{sort: 'valor_liberado', order:'Desc'}},
        {descricao: "Menores valores de pagamento estimado", valor:{sort: 'valor_liberado', order:'Asc'}},
        {descricao: "Maiores valores de glosa estimada", valor:{sort: 'valor_glosado', order:'Desc'}},
        {descricao: "Menores valores de glosa estimada", valor:{sort: 'valor_glosado', order:'Asc'}}
      ]
    };
  },
  filters: {
    formatDateHour(date) {
      return moment(date).format('L') + ' às ' + moment(date).format('LT') + 'h' 
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  methods: {
    downloadFile(acao, filterData, doCallBack) {
      // let acao = "getcsvpagamentosprocessamento"
      // if(this.pagination.total_pages > 200){
      //     let paramModal = {
      //     type: "warning",
      //     title: "Tamanho de arquivo excedido",
      //     message: `<p>Restrinja a sua busca para fazer o download do resultado</p>`,
      //     callback: null,
      //     btConfirm: { name: "", show: false },
      //     btCancel: { name: "Ok", show: true },
      //   };
      //   this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      //   return
      // }
      this.$store.commit("showLoader", { circle: true }, {root: true});
      let Payload = {...filterData}
      this.$store.dispatch("documents/getDocumentPost", { Payload, acao, callback: doCallBack? ()=> setTimeout(()=>{ 
        this.getList(this.filterData, this.pagination.offset)
        //this.$store.commit("hideLoader")
      }, 500) : null }, {root:true})

    },
    getFile(doc_id){
       this.$store.dispatch("documents/getDocument", {doc_id})
    },
    setFilter(item, filterName){
      let login_valido = !item.erro ? true :false
      let operadora_ans_id = [Number(item.operadora_ans_id)]
      let prestador_id = [Number(item.prestador_id)]
      let grupo_economico = this.$store.state.permissions.grupoEconomico
      let filter = {
        filterData: {
          grupo_economico,
          login_valido,
          operadora_ans_id, 
          prestador_id,
        },
        filterName: filterName? filterName :'identNaOperadoraFilter',
        redirect: true
      }
      this.$store.commit('recebiveis/setFilter', filter, { root:true })
    }
  },
  watch:{
    list() {
      this.panel = false
    },
    filterData(val){
        this.orderBy =  (val && val.sort) ? 
        this.orderByList.find(el=> el.valor && el.valor.sort == val.sort && el.valor.order == val.order).valor 
        : null
    }
  },
  props: {
    list: Array,
    pagination: Object,
    filterData: Object,
    showOpen: Function,
    historico: Array,
    getList: Function,
    getDocument: Function,
    grupo_economico: Number,
    totais: Object
  },
};
</script>

<style lang="scss">
.no-box-shadow,
.no-box-shadow * {
  box-shadow: 0 0 0 0 !important;
}
button.v-expansion-panel-header {
  background-color: #eff3f8;
  border-radius: 2px;
  padding: 0;
}
.v-expansion-panel::before {
  box-shadow: none;
}
.v-expansion-panel-content {
  display: flex;
  margin: 0 -24px;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #ffffff;
}
.text-list {
  font-size: 13px;
}
.text-list.space {
  margin-right: 3px;
}
.text-list.pres {
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.warning-header {
  position: absolute;
  margin-top: 9px;
  margin-left: 5px;
}
.check-content {
  position: absolute;
  margin-top: -16px;
}
.check-border {
  border: none;
}
#dataTable {
  .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: #ffffff;
  }
  ::-webkit-scrollbar {
    height: 26px;
  }
  ::-webkit-scrollbar-track {
    background-color: #ffffff;
  }
  ::-webkit-scrollbar-thumb:hover {
    border-radius: 50px;
    background-color: #dad7d7;
    border: 10px solid #ffffff;
  }
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
  .v-data-table > .v-data-table__wrapper > table > thead > tr > td,
  .v-data-table > .v-data-table__wrapper > table > thead > tr > th,
  .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
  .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
    padding: 0 4px;
    transition: height 0.2s cubic-bezier(0.4, 0, 0.6, 1);
  }
  .v-input--selection-controls__ripple {
    height: 0px;
  }
  tr {
    height: 38px;
  }
  .theme--light.v-data-table tbody tr.v-data-table__selected {
    background: #ffffff;
  }
  td.text-arquivo {
    border-left: none;
    max-width: 165px;
  }
  td.text-start {
    border-right: none;
  }
  th.text-arquivo {
    border-left: none;
  }
  th.text-start {
    border-right: none;
  }
  td.text-qtdItens {
    text-align: center;
  }
  th.text-data_auto {
    border-left: none;
  }
  .scroll-cursor .v-data-table__wrapper {
    cursor: grab;
  }
  .scroll-cursor .v-data-table__wrapper:active {
    cursor: grabbing;
  }
}
</style>